import { Button } from "@material-ui/core";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

export default function QuoteFailure(props) {
    return (
        <Container>
            {props.yourInformation && props.yourInformation.morganStanleyTicketErrorMessages.length > 0 && props.yourInformation.morganStanleyTicketErrorMessages.map((element, i) =>
                <Row>
                    <div className="alert alert-danger mt-2">
                        <span><b>{element.errorCode}&nbsp;&nbsp;</b></span>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: element.errorMessage
                          }}
                        />
                    </div>
                </Row>
            )}
            <Row>
                <div className="mt-4">
                    Your illustration has been stored, but no ITS Ticket has been created. For additional support, please leverage the AI@MS Assistant.
                    We will automatically retry your illustration submission hourly to create an ITS Ticket. You will be notified when the ticket is created.
                    You can also access this link to proceed to the Insurance Ticketing System (ITS) to manually create an ITS Ticket using the Reference ID provided below.
                </div>
            </Row>
            <Row>
                <div className="mt-4">Reference ID:</div>
            </Row>
            <Row>
                <a className="BlueLink mt-2" target="_blank" href={`/ActivityCenter/${props.yourInformation.referenceID}`}>{props.yourInformation.referenceID ? props.yourInformation.referenceID : ''}</a>
            </Row>
            <Row>
                <Col md={3} className="pl-0 mt-4">
                    <Button type="submit" variant="contained" className='w-100' size="large" color="primary" onClick={props.onBack}>Retry Submission</Button>
                </Col>
                <Col md={3} className="mt-4">
                    <Button type="submit" variant="contained" className='w-100' size="large" color="primary" onClick={() => props.clearFormState()}>Submit Another Quote</Button>
                </Col>
                <Col md={6}></Col>
            </Row>
        </Container>
    )
};


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/SubComponents/QuoteFailure.js